import { Component, OnInit } from '@angular/core';
import { SplashScreenStateService } from 'src/app/services/splash-screen-state-service';
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

// The screen starts with the maximum opacity
public opacityChange = 1;

//public a splashTransition;

// First access the splash is visible
public showSpinnerNew = true;

readonly ANIMATION_DURATION = 1;
public spinnerTransition: any;

constructor(
  private splashScreenStateService: SplashScreenStateService
) { }

ngOnInit(): void {

  // Somewhere the stop method has been invoked
  this.splashScreenStateService.subscribe((res: any) => {
    
     this.hideSpinnerAnimation();
  });

}



public hideSpinnerAnimation() {
  // Setting the transition
  this.spinnerTransition = `opacity ${this.ANIMATION_DURATION}s`;
  this.opacityChange = 0;

  setTimeout(() => {
     // After the transition is ended the showSplash will be hided
     this.showSpinnerNew = false; // !this.showSpinnerNew;
  }, 500);
}



}
